import {CATALOG_ROUTES, CATALOG_ROUTES_KEYS, CATALOG_ROUTES_TO_URL} from '../../constants';
import {useMemo} from 'react';
import {IRouteItem, TCatalogRoute, TCatalogRouteKey} from '../../types';

export const useCatalogRoutes = (): Record<TCatalogRouteKey, IRouteItem<TCatalogRoute>> => {
    const routesFactory = () => {
        const routes = Object.values(CATALOG_ROUTES_KEYS).reduce(
            (urls: Record<string, IRouteItem<TCatalogRoute>>, section: TCatalogRouteKey) => {
                const url = () => CATALOG_ROUTES_TO_URL[section];
                const to = () => url();
                urls[section] = {section: CATALOG_ROUTES[section], to, url};
                return urls;
            },
            {},
        );

        return routes as Record<TCatalogRouteKey, IRouteItem<TCatalogRoute>>;
    };

    return useMemo(routesFactory, []);
};
